export default __webpack_public_path__ + "static/media/guardofdancingsteel3.339f794c.png";